<div class="card">
    <div class="card-body">
        <h5 class="card-title main-blue">{{'PurchaseEdit.purchase' | translate}}</h5>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">{{'PurchaseEdit.purchaseNumber' | translate}}</div>
                <div class="col-sm-10">{{purchase.purchaseSetNumber}}</div>
            </div>

            <div class="row">
                <div class="col-sm-2 bolded">{{'PurchaseEdit.date' | translate}}</div>
                <div class="col-sm-10">{{purchase.date | bcDate }}</div>
            </div>

            <div class="row">
                <div class="col-sm-2 bolded">{{'PurchaseEdit.status' | translate}}</div>
                <div class="col-sm-10">{{purchase.status}}</div>
            </div>

            <div class="row">
                <div class="col-sm-2 bolded">{{'PurchaseEdit.buyer' | translate}}</div>
                <div class="col-sm-10">{{purchase.finalizedBy}}</div>
            </div>
        </div>
    </div>
</div>